// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"32404356","232":"17021de3","237":"6ab25928","526":"811dd526","787":"9d2f73d8","872":"e6387a96"}[chunkId] + ".chunk.js";
};